module.exports = __webpack_public_path__ + "img/sj_xinggang.682523d0.jpg";